export const CREATE_FILES_REQUEST = "CREATE_FILES_REQUEST";
export const CREATE_FILES_SUCCESS = "CREATE_FILES_SUCCESS";
export const CREATE_FILES_FAIL = "CREATE_FILES_FAIL";